import LargeButton from "./LargeButton";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";

import "../styles/MapCreator.css";
import useAxiosRequest from "../hooks/useAxiosRequest";
import TemplateOption from "./TemplateOption";

import config from '../config.json';

const MapCreator = () => {
    const { isLoading, data: templates, error } = useAxiosRequest({
        url: `${config.backendUrl}/maps/templates`,
        withCredentials: true,
        method: "get"
    });

    if (isLoading) return;

    if (error) return (
        <LargeButton
            name="Encountered error"
            desc={error.toString()}
            icon={faCircleExclamation}
            color="#a10000"/>
    );

    if (!templates.length) return;

    return <div id="map-creator">{templates.map(template => <TemplateOption key={template._id} template={template}/>)}</div>;
}

export default MapCreator;
